<script>
    import { onDestroy, onMount } from "svelte";

    import {
        Button,
        PageLoading,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import PatientDetailsSection from "./createEditSections/PatientDetailsSection.svelte";
    import PatientContactSection from "./createEditSections/PatientContactSection.svelte";
    import ProcedureDetailsSection from "./createEditSections/ProcedureDetailsSection.svelte";
    import InsuranceDetailsSection from "./createEditSections/InsuranceDetailsSection.svelte";
    import SurgeonDetailsSection from "./createEditSections/SurgeonDetailsSection.svelte";

    import {
        goBack,
        setInputFilter,
        goToURL,
        showError,
        showException,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        loggedInDoctorDetail,
        insuranceFund,
        accountDoctors,
        user,
    } from "../../../stores";

    import {
        resetIrrelevantInsuranceDetails,
        syncInsuranceDetailsOfLatestBillingData,
    } from "../../PatientEncounter/helpers/encounterHelper.svelte";

    import { defaultState } from "../../../Utils/utilEnums.svelte";

    export let isEditDuplicate, isDuplicateFromTable;

    export let patientEncounterId;

    export let updatePatientDetails = () => {};

    export let updatePatientEncounterDetails = () => {};

    let isLoadingDoctor = false,
        isLoadingPatientEncounterDetails = false,
        isUpdatingPatientEncounter = false,
        patientDetails = {},
        patientEncounterDetails = {},
        selectedDoctorProvider = {},
        insuranceDetails = {},
        selectedSurgeon = {},
        selectedHospital = {},
        createSurgeonFilters = { state: defaultState };

    let patientContactDetails = { useAsContact: false },
        patientContactsArr = [];

    let errorFields = [];

    let isOpvSuggestionsAttempt = false,
        isShowConfirmModalAfterAttempt = false;

    let patientSectionRef,
        patientContactRef,
        procedureDetailsRef,
        insuranceDetailsRef,
        surgeonDetailsRef;

    // if set TRUE then no validation check on submission
    let overrideValidation = false;

    $: isLoading = isLoadingDoctor || isLoadingPatientEncounterDetails;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (patientDetails.insuranceType == 15) {
        const patientMedicareNoField = document.getElementById(
            "patientMedicareNoField",
        );
        const patientMedicareRefNoField = document.getElementById(
            "patientMedicareRefNoField",
        );
        if (patientMedicareNoField) {
            patientMedicareNoField.style.outline = "";
            patientMedicareNoField.placeholder = "Medicare No.";
        }
        if (patientMedicareRefNoField) {
            patientMedicareRefNoField.style.outline = "";
            patientMedicareRefNoField.placeholder = "Medicare Ref No.";
        }
    } else updateInputFields();

    $: if (
        patientEncounterDetails.doctor?.id &&
        $loggedInDoctorDetail.id !== patientEncounterDetails.doctor?.id
    )
        loadDoctor(patientEncounterDetails.doctor.id);

    $: isValidPatientContact = _checkPatientContactValidation(
        patientContactDetails,
    );

    onMount(async () => {
        if (isFlowEnableSearchDoctor) {
            $accountDoctors = [];
        }

        if (patientEncounterId)
            await loadPatientEncounterDetails(patientEncounterId);

        setTimeout(() => {
            updateInputFields();
        }, 1000);
    });

    onDestroy(() => {
        if (isFlowEnableSearchDoctor) {
            $loggedInDoctorDetail = {};
            $accountDoctors = [];
        }
    });

    const loadPatientEncounterDetails = async (patientEncounterId) => {
        isLoadingPatientEncounterDetails = true;

        await apiMethods.getMethod
            .getPatientEncounterById(patientEncounterId)
            .then((res) => {
                if (res.id == patientEncounterId)
                    _syncPatientEncounterDetails(res);
            })
            .catch((err) => showException(err));

        isLoadingPatientEncounterDetails = false;
    };

    const loadDoctor = (id) => {
        isLoadingDoctor = true;

        // each time when trigger this function means doctor changes, thus reset these two
        $loggedInDoctorDetail = {};

        apiMethods.getMethod
            .getAccountById(id)
            .then((res) => {
                if (res.id) $loggedInDoctorDetail = { ...res };
            })
            .then(() => (isLoadingDoctor = false));
    };

    const updateInputFields = () => {
        setInputFilter(
            document.getElementById("patientMedicareNoField"),
            function (value) {
                return value ? /^[0-9-\s]+$/i.test(value) : true;
            },
            "Must be an integer",
        );

        setInputFilter(
            document.getElementById("patientMedicareRefNoField"),
            function (value) {
                return value ? /^[0-9]+$/.test(value) : true;
            },
            "Must be an integer",
        );

        setInputFilter(
            document.getElementById("insuranceDetailsMembershipNoField"),
            function (value) {
                return value ? /^[A-z0-9]+$/.test(value) : true;
            },
            "Must be either an integer or a character",
        );

        setInputFilter(
            document.getElementById("insuranceDetailsMembershipRefNoField"),
            function (value) {
                return value ? /^[0-9]+$/.test(value) : true;
            },
            "Must be an integer",
        );
    };

    const handleUpdateEncounter = async () => {
        // this function will remove all irrelevant insurance details than selected one
        // await removeIrrelevantInsuranceDetails();

        await updatePatient();
    };

    const removeIrrelevantInsuranceDetails = () => {
        const cleanUpDataObj = resetIrrelevantInsuranceDetails(
            patientDetails,
            insuranceDetails,
        );

        patientDetails = cleanUpDataObj.patientDetails;
        insuranceDetails = cleanUpDataObj.insuranceDetails;
    };

    const updatePatient = async () => {
        if (await _checkInputFieldsValid()) {
            isUpdatingPatientEncounter = true;

            _updatePatientDetails();

            _updatePatientInsuranceDetails();

            if (!patientEncounterDetails.scheduledTime)
                patientEncounterDetails.scheduledTime = "00:00:00";
            else if (
                patientEncounterDetails.scheduledTime.split(":").length < 3
            )
                patientEncounterDetails.scheduledTime += ":00";

            patientEncounterDetails.scheduledDate =
                patientEncounterDetails.scheduledDate
                    ? patientEncounterDetails.scheduledDate.split("T")[0] +
                      "T" +
                      patientEncounterDetails.scheduledTime
                    : null;

            // if (!isEditDuplicate) await updateProcess(patientDetails);
            // else await checkPatientProcess(patientDetails);
            if (isEditDuplicate) await checkPatientProcess(patientDetails);
            else await updateProcess(patientDetails);

            isUpdatingPatientEncounter = false;
        }
    };

    const updateProcess = async (pd) => {
        let isPatientUpdated = false;

        await apiMethods.putMethod
            .updatePatient(pd)
            .then(async (res) => {
                if (res.id) {
                    if (isValidPatientContact) await updatePatientContact();
                    _updatePatientEncounterDetails(res);
                    isPatientUpdated = true;
                } else showError(res.error);
            })
            .catch((err) => showException(err));

        if (isPatientUpdated) await updatePatientEncounter();
    };

    const updatePatientEncounter = async () => {
        await apiMethods.putMethod
            .updatePatientEncounter(patientEncounterDetails, false, "Fee estimate update - edit section")
            .then((res) => {
                if (res.id) {
                    updatePatientDetails(patientDetails);
                    updatePatientEncounterDetails(res);
                    goBack();
                } else showError(res.error);
            })
            .catch((err) => showException(err));

        isUpdatingPatientEncounter = false;

        goToURL(
            `/PatientQuote/view/${patientEncounterDetails.id}/tab=generalInfo`,
        );
    };

    const checkPatientProcess = async (pd) => {
        if (!pd.medicareNo) pd.medicareNo = "";
        if (!pd.membershipNo) pd.membershipNo = "";

        // check !delete patient by first & middle & last name && dob && medicareNo
        // await apiMethods.postMethod
        //     .matchPatient(pd, $loggedInDoctorDetail.id)
        //     .then(async (res) => {
        //         if (res.id) {
        //             if (isValidPatientContact) await updatePatientContact();
        //             _updatePatientEncounterDetails(res);
        //             createPatientEncounter();
        //         } else await createProcess(pd);
        //     });
        await createProcess(pd);
    };

    const createProcess = async (pd) => {
        let isPatientCreated = false;

        await apiMethods.postMethod
            .createPatient(pd)
            .then((res) => {
                if (res.id) {
                    _updatePatientEncounterDetails(res);
                    isPatientCreated = true;
                }
            })
            .catch((err) => showException(err));

        if (isPatientCreated) await createPatientEncounter();
    };

    const createPatientEncounter = () => {
        const encounterObj = {
            ...patientEncounterDetails,
            billingData: [],
            estimates: [],
            invoices: [],
            skipQuote: false,
            billingStatus: 0,
        };

        delete encounterObj.id;

        apiMethods.postMethod
            .createPatientEncounter(encounterObj)
            .then((res) => {
                if (res.id) goToURL(`/PatientQuote/view/${res.id}`);
            })
            .catch((err) => showException(err));
    };

    const updatePatientContact = async () => {
        if (!patientContactDetails.id) await _addPatientContact();
        else _editPatientContact();
    };

    const closeConfirmModalAfterAttempt = () => {
        isShowConfirmModalAfterAttempt = false;
        isUpdatingPatientEncounter = false;
        isOpvSuggestionsAttempt = false;
    };

    const showDotActionsMenu = () => {
        if (document.getElementById("encounterActionMenu"))
            document.getElementById("encounterActionMenu").style.display =
                "flex";
    };

    const hideDotActionsMenu = () => {
        if (document.getElementById("encounterActionMenu"))
            document.getElementById("encounterActionMenu").style.display =
                "none";
    };

    // HELPER FUNCTIONS
    const _syncPatientEncounterDetails = (res) => {
        const { patient, doctorProvider, surgeon, hospital } = res;

        patientEncounterDetails = {
            ...res,
            defaultBillingStatus: res.billingStatus,
        };

        patientDetails = { ...patient };

        if (
            (patientDetails.title == 0 || patientDetails.title == 20) &&
            patientDetails.sex == 2
        )
            delete patientDetails.title;

        if (patientDetails.title == 0 || patientDetails.title == 4)
            patientDetails.sex = 0;

        if (
            patientDetails.title == 1 ||
            patientDetails.title == 2 ||
            patientDetails.title == 3
        )
            patientDetails.sex = 1;

        // Merge patient insurance type from 0, 1, 2 to 0 (Private)
        if (
            patientDetails.insuranceType == 1 ||
            patientDetails.insuranceType == 2
        )
            patientDetails.insuranceType = 0;

        if (
            patientDetails.birthDate &&
            (new Date(patientDetails.birthDate).getFullYear() < 1900 ||
                new Date(patientDetails.birthDate) > new Date())
        )
            delete patientDetails.birthDate;

        // sync patientContact details
        const { patientContacts } = patientDetails;

        patientContactsArr = [...patientContacts];

        if (patientContacts.length) {
            if (patientContacts.some((contact) => contact.useAsContact))
                patientContactDetails = patientContacts.find(
                    (contact) => contact.useAsContact,
                );
            else patientContactDetails = patientContacts[0];
        }

        selectedDoctorProvider.details = doctorProvider
            ? { ...doctorProvider }
            : null;

        selectedSurgeon.details = surgeon ? { ...surgeon } : null;

        selectedHospital.details = hospital ? { ...hospital } : null;

        if (!selectedHospital.details) selectedHospital.outsideHospital = true;
        else selectedHospital.outsideHospital = false;

        _updateScheduleDate(res.scheduledDate);

        _syncInsuranceDetails(patient);

        // Reset procedure details && surgeon details if duplicate from View Encounter
        if (isEditDuplicate && !isDuplicateFromTable) {
            selectedSurgeon = {};
            selectedHospital = {};
            patientEncounterDetails.procedureName = "";
            patientEncounterDetails.typeOfBill = Number(0);
            patientEncounterDetails.neuraxialType = Number(0);
            if (patientEncounterDetails.scheduledDate)
                delete patientEncounterDetails.scheduledDate;
        }
    };

    const defaultOverseasFund = {
                                    id: 0,
                                    name: "Other Overseas Insurance"
                                };

    const _syncInsuranceDetails = (patient) => {
        if (patientDetails.insuranceType == 0) {
            insuranceDetails.insuranceFund = $insuranceFund.find(
                (fund) => fund.id == patient.insuranceId,
            );
            insuranceDetails.membershipNo = patient.membershipNo;
            insuranceDetails.membershipRefNo = patient.membershipRefNo;

            insuranceDetails.privateCoverType = patient.insurance;
        } else if (patientDetails.insuranceType == 10) {
            insuranceDetails.overseasCover = patient.insurance;
            insuranceDetails.membershipNo = patient.membershipNo;
            insuranceDetails.membershipRefNo = patient.membershipRefNo;
            if(patient.insuranceId != 0) {
                insuranceDetails.insuranceFund = $insuranceFund.find(
                    (fund) => fund.id == patient.insuranceId,
                );
            } else {
                //default overseas fund selected
                insuranceDetails.insuranceFund = defaultOverseasFund;
            }
        }
    };

    const _updatePatientDetails = () => {
        const { title, birthDate, medicareRefNo, insuranceType } =
            patientDetails;

        if (title == "Title") patientDetails.title = 20;

        if (!birthDate) patientDetails.birthDate = "2999-01-01T00:00:00";

        if (medicareRefNo) patientDetails.medicareRefNo = Number(medicareRefNo);
        else patientDetails.medicareRefNo = null;
    };

    const _updatePatientInsuranceDetails = () => {
        const { insuranceType } = patientDetails;

        // if (patientDetails.insurance) delete patientDetails.insurance;
        // if (patientDetails.insuranceId) delete patientDetails.insuranceId;
        // if (patientDetails.membershipNo) delete patientDetails.membershipNo;
        // if (patientDetails.membershipRefNo)
        //     delete patientDetails.membershipRefNo;

        switch (insuranceType) {
            case 0: // Private
                const {
                    insuranceFund,
                    membershipNo,
                    membershipRefNo,
                    privateCoverType,
                } = insuranceDetails;

                if (insuranceFund?.id)
                    patientDetails.insuranceId = insuranceFund.id;

                patientDetails.membershipNo = membershipNo ?? "";

                patientDetails.membershipRefNo = membershipRefNo
                    ? Number(membershipRefNo)
                    : null;

                if (privateCoverType)
                    patientDetails.insurance = privateCoverType;
                break;
            case 10: // Overseas cover
                patientDetails.insurance = insuranceDetails.overseasCover;
                patientDetails.membershipNo = insuranceDetails.membershipNo;
                patientDetails.membershipRefNo =
                    insuranceDetails.membershipRefNo
                        ? Number(insuranceDetails.membershipRefNo)
                        : null;
                if (insuranceDetails.insuranceFund)
                    patientDetails.insuranceId =
                        insuranceDetails.insuranceFund.id;
                break;
            case 11: // Self insured
            case 15: // Cosmetic
                break;
            default:
                break;
        }
    };

    const _updatePatientEncounterDetails = (patientDetails) => {
        patientEncounterDetails = {
            ...patientEncounterDetails,
            patient: { ...patientDetails },
            doctor: { id: $loggedInDoctorDetail.id },
            surgeon: !selectedSurgeon.details
                ? { id: 0 }
                : {
                      id: selectedSurgeon.details.id,
                      providerUniqueId:
                          selectedSurgeon.details.providerUniqueId,
                  },
            hospital: { id: selectedHospital.details?.id ?? 0 },
            doctorProvider: { number: selectedDoctorProvider.details.number },
        };

        if (patientEncounterDetails.hospital.id == 0)
            patientEncounterDetails.hospitalId = 0;

        patientEncounterDetails = syncInsuranceDetailsOfLatestBillingData(
            patientEncounterDetails,
        );
    };

    const _updateScheduleDate = (scheduledDate) => {
        if (!scheduledDate) {
            patientEncounterDetails.scheduledTime = null;
            return;
        }

        const year = scheduledDate.split("-")[0];

        if (Number(year) < 1900) delete patientEncounterDetails.scheduledDate;

        const date = scheduledDate.split("T")[0];
        const time = scheduledDate.split("T")[1].slice(0, 5);

        patientEncounterDetails.scheduledDate = `${date}`;
        patientEncounterDetails.scheduledTime = `${time}`;
    };

    const _checkInputFieldsValid = async () => {
        errorFields = [];

        await _updateInvalidFieldsStyle();

        return errorFields.length == 0;
    };

    const _updateInvalidFieldsStyle = async () => {
        const patientDetailsCheck =
            await patientSectionRef.checkPatientDetailsValidation();

        if (patientDetailsCheck.length)
            errorFields = [...errorFields, ...patientDetailsCheck];

        const patientContactCheck =
            await patientContactRef.checkPatientContactValidation();

        if (patientContactCheck.length)
            errorFields = [...errorFields, ...patientContactCheck];

        const procedureDetailsCheck =
            await procedureDetailsRef.checkProcedureDetailsValidation();

        if (procedureDetailsCheck.length)
            errorFields = [...errorFields, ...procedureDetailsCheck];

        const insuranceDetailsCheck =
            await insuranceDetailsRef.checkInsuranceDetailsValidation(
                patientDetails,
            );

        if (insuranceDetailsCheck.length)
            errorFields = [...errorFields, ...insuranceDetailsCheck];

        // const surgeonDetailsCheck =
        //     await surgeonDetailsRef.checkSurgeonDetailsValidation();

        // if (surgeonDetailsCheck.length)
        //     errorFields = [...errorFields, ...surgeonDetailsCheck];

        if (errorFields.length) {
            const scrollToElement = document.getElementById(errorFields[0]);
            if (scrollToElement)
                scrollToElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    const _addPatientContact = async () => {
        await apiMethods.postMethod
            .createPatientContact({
                ...patientContactDetails,
                patientId: patientDetails.id,
            })
            .catch((err) => showException(err));
    };

    const _editPatientContact = async () => {
        await apiMethods.putMethod
            .updatePatientContact(patientContactDetails)
            .catch((err) => showException(err));
    };

    const _checkPatientContactValidation = (contact = {}) => {
        return (
            contact.name ||
            contact.relationship ||
            contact.email ||
            contact.phone
        );
    };
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <div class="flex-1 flex mt-4 w-full">
        <form class="flex flex-col flex-1 gap-y-4 overflow-y-auto">
            <div class="flex flex-1 w-full items-center justify-end">
                <div class="flex items-center gap-x-2">
                    <Button
                        clickFunc={handleUpdateEncounter}
                        isDisabled={isUpdatingPatientEncounter}
                        defaultClass="btn btn-sm btn-secondary text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                        manualClass={isUpdatingPatientEncounter
                            ? "loading"
                            : ""}
                    >
                        {isUpdatingPatientEncounter ? "Saving" : "Save"}
                    </Button>

                    <div class="flex-none" on:mouseleave={hideDotActionsMenu}>
                        <ul class="menu menu-horizontal p-0">
                            <li tabindex="0" class="justify-end">
                                <div
                                    class="flex"
                                    on:mouseenter={showDotActionsMenu}
                                >
                                    <div
                                        class="flex items-center justify-center"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"
                                        ></i>
                                    </div>
                                </div>
                                <ul
                                    id="encounterActionMenu"
                                    class="z-[100] bg-secondary"
                                >
                                    <Button
                                        clickFunc={() => {
                                            overrideValidation =
                                                !overrideValidation;
                                        }}
                                        defaultClass="btn btn-sm btn-secondary text-white text-xs flex-none border-none w-auto h-10 px-1 min-w-[200px]"
                                    >
                                        <div
                                            class="flex items-center justify-between gap-x-2"
                                        >
                                            <input
                                                type="checkbox"
                                                class="toggle toggle-secondary toggle-sm"
                                                id="overrideValidationCheckbox"
                                                checked={overrideValidation}
                                                on:click={(e) => {
                                                    e.stopPropagation();
                                                    overrideValidation =
                                                        !overrideValidation;
                                                }}
                                            />
                                            <label
                                                for="overrideValidationCheckbox"
                                                class="cursor-pointer text-xs"
                                            >
                                                Override Validation
                                            </label>
                                        </div>
                                    </Button>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <PatientDetailsSection
                bind:this={patientSectionRef}
                bind:patientDetails
                {isEditDuplicate}
                {overrideValidation}
            />

            <PatientContactSection
                bind:this={patientContactRef}
                bind:patientContactDetails
                bind:patientEncounterDetails
                bind:patientContactsArr
                isEditEncounter
                {patientDetails}
                {overrideValidation}
            />

            <ProcedureDetailsSection
                bind:this={procedureDetailsRef}
                bind:patientEncounterDetails
                bind:selectedSurgeon
                bind:selectedHospital
                bind:createSurgeonFilters
                typeOfBill={patientEncounterDetails.typeOfBill}
                {overrideValidation}
            />

            <InsuranceDetailsSection
                bind:this={insuranceDetailsRef}
                bind:patientDetails
                bind:insuranceDetails
                bind:selectedHospital
                bind:selectedDoctorProvider
                bind:createSurgeonFilters
                {overrideValidation}
            />

            <!-- <SurgeonDetailsSection
                bind:this={surgeonDetailsRef}
                bind:selectedSurgeon
                bind:selectedHospital
                bind:createSurgeonFilters
            /> -->

            <Button
                clickFunc={handleUpdateEncounter}
                isDisabled={isUpdatingPatientEncounter}
                defaultClass="btn btn-sm btn-secondary text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                manualClass={isUpdatingPatientEncounter ? "loading" : ""}
            >
                {isUpdatingPatientEncounter ? "Saving" : "Save"}
            </Button>
        </form>
    </div>
{/if}

<div
    class={isShowConfirmModalAfterAttempt
        ? "modal modal-open sm:modal-middle"
        : "modal"}
>
    <div class="modal-box">
        <h3 class="font-medium text-lg">
            OPV failed for patient. Save anyway?
        </h3>
        <div class="modal-action flex justify-center gap-x-4">
            <button
                class="btn btn-error text-white btn-sm border-none w-24"
                on:click={closeConfirmModalAfterAttempt}
            >
                Cancel
            </button>
            <button
                class="btn btn-secondary text-white btn-sm border-none w-24"
                on:click={() => updateProcess(patientDetails)}
            >
                Save
            </button>
        </div>
    </div>
</div>
